const DeliverableType = {
  Swift: 'Swift',
  AccountStatement: 'AccountStatement',
  Invoice: 'Invoice',
};

export default DeliverableType;
